/**
 * TreeNodeIcon  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { Icon, ICON_SIZE } from "../Icon";
import { ITreeNode } from "./TreeViewTypes";

export interface ITreeNodeIconProps {
	node?: ITreeNode;
}

export const TreeNodeIcon: React.FC<ITreeNodeIconProps> = ({ node: { icon } = {} }) =>
	icon ? <Icon name={icon} size={ICON_SIZE.XSMALL} /> : null;
